/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import axios from "axios";
import {
	MDBCarousel,
	MDBCarouselInner,
	MDBCarouselItem,
	MDBView,
} from "mdbreact";

export default function BannerCarousel({ bannerKey }) {
	const [banners, setBanners] = useState(null);

	useEffect(() => {
		axios
			.get(`https://servico.feevale.br/site/v2/banners/${bannerKey}`)
			.then((res) => {
				const banners = res.data?.Blocks[0]?.Items; // Recupera o primeiro bloco de um banner group.
				setBanners(banners);
			});
	}, []);

	if (banners !== null && banners !== undefined) {
		return (
			<MDBCarousel
				activeItem={1}
				length={banners?.length}
				showControls={banners?.length > 1 ? true : false}
				showIndicators={false}
				className="z-depth-1"
			>
				<MDBCarouselInner>
					{banners.map((i, index) => {
						let mediaItem = i?.Body?.Media;
						if (mediaItem !== null) {
							if (mediaItem.Description?.length > 0) {
								return (
									<MDBCarouselItem key={"banner_" + index} itemId={index + 1}>
										<MDBView>
											<a href={mediaItem.Description}>
												<img
													className="d-block w-100 img-fluid"
													src={mediaItem.PublicUrl}
													alt={mediaItem.AltText}
												/>
											</a>
										</MDBView>
									</MDBCarouselItem>
								);
							}
							return (
								<MDBCarouselItem key={"banner_" + index} itemId={index + 1}>
									<MDBView>
										<img
											className="d-block w-100"
											src={mediaItem.PublicUrl}
											alt={mediaItem.AltText}
										/>
									</MDBView>
								</MDBCarouselItem>
							);
						}
					})}
				</MDBCarouselInner>
			</MDBCarousel>
		);
	}

	return <></>;
}
